const MONTHS_ES = {
  enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
  julio: 6, agosto: 7, septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11,
};

/** Convierte "06 de mayo, 2026" en un objeto Date. */
export function parseSpanishDate(str) {
  const m = str.match(/(\d{1,2}) de (\w+),? (\d{4})/);
  if (!m) return null;
  const [, day, month, year] = m;
  const mIdx = MONTHS_ES[month.toLowerCase()];
  if (mIdx === undefined) return null;
  return new Date(Number(year), mIdx, Number(day));
}

/** Convierte "06 de mayo, 2026" en "2026-05-06" (ISO 8601, para datePublished). */
export function toISODate(str) {
  const d = parseSpanishDate(str);
  if (!d) return undefined;
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
